/** Workspace collections refresh together; personal pages and open editors keep their state. */
const SCOPED_PAGES = new Set([
  'dashboard', 'tree', 'employees', 'directory', 'compensation', 'attendance',
  'change-log', 'past', 'calendar', 'candidates', 'documents', 'job-descriptions',
  'reports', 'plan-coverage', 'all-workflows', 'inbox', 'complaints', 'employee-reports',
]);

export function workspacePageKey(route, country) {
  return SCOPED_PAGES.has(String(route.name)) ? `${route.name}:${country}` : undefined;
}

/** Only collection reads/exports receive workspace context. Never rewrite employee forms. */
const SCOPED_READS = new Set([
  'dashboard/org-summary', 'dashboard/stats', 'charts/get', 'charts/drill',
  'organogram/tree/get', 'employees/get', 'employees/export', 'employees/recycle/get',
  'candidates/get', 'attendance/today', 'attendance/today/drill', 'attendance/get',
  'attendance/export', 'attendance/schedule', 'attendance/calendar/get',
  'compensation/get', 'compensation/export', 'compensation/report', 'compensation/summary',
  'payroll-reports/get', 'payroll-reports/export', 'employee-reports/get',
  'workflow/pending', 'workflow/inbox', 'workflow/inbox/summary', 'plans/get',
  'appraisals/get', 'audit/global/get', 'audit/summary', 'complaints/get', 'jd/issued/list',
]);

export function isWorkspaceCountryRead(url, data = {}) {
  data = data || {};
  const path = String(url || '').split('?')[0].replace(/^\/+|\/+$/g, '');
  if (path === 'complaints/manage') return ['list', 'submit'].includes(data.action);
  if (path === 'time-off/requests/get') return !data.request_id && ['supervisor', 'hr'].includes(data.scope);
  if (['plans/get', 'appraisals/get'].includes(path)) return !data.employee_id && !data.plan_id && !data.appraisal_id;
  if (['compensation/get', 'employee-reports/get', 'candidates/get'].includes(path) && (data.employee_id || data.report_id || data.candidate_id)) return false;
  if (SCOPED_READS.has(path)) return true;
  return path === 'documents/catalog/get' && data.mode !== 'types';
}

export function countryBadge(country) {
  return ({ US: 'US', UK: 'GB', Moldova: 'MD', Spain: 'ES' })[country] || '';
}
